module.exports = __webpack_public_path__ + "img/Democritus.4a831124.jpg";